import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getAccessRulesAPI() {
  const url = `${AWS_API_URL}/2n/access-rules`;

  return getRequest(url, await authorize());
}
